function WhatsappMessage(number){
    let message = "";

    function write(val, breakLine){
        const breackChar = new Array(breakLine).fill("%0a").join("");
        message += val + breackChar;
    }

    function send(){
        window.location.href = `https://api.whatsapp.com/send?phone=${number}&text=${message}`;
    }

    function clear(){
        message = "";
    }

    return {
        write,
        send,
        clear
    };
}

export default WhatsappMessage;